import React from "react";
import TextCard from "../../Component/TextCard";
import { webPath } from "../../apiconfig";
import "../../Styles/TagPage/HotSeatComp.css";
const LearningComp = ({ data }) => {
  return (
    <div>
      <div className="container mt-5 mb-5">
        <div className="row">
          <h5 className="fw-bold borderB py-1 h4 text-black">
            Learning Center
          </h5>

          {data && data.length > 0 ? (
            data.slice(0, 3).map((item) => (
              <div className="col-md-4 mt-4" key={item.id}>
                <a
                  href={`/${item.cat_slug}/${item.post_name}`}
   
                    className="d-flex w-100 learning-card-link"
                  style={{ textDecoration: "none", color: "inherit", alignItems: "flex-start" }}
                >
                  <div style={{ width: "50%" }}>
                    <img
                      src={`${webPath}${item?.banner_img}`}
                      alt={item?.post_name}
                      style={{
                        width: "92%",
                        height: "130px",
                        objectFit: "cover",
                        borderRadius: "14px",
                      }}
                    />
                  </div>
                  <div style={{ width: "50%", paddingLeft: "10px" }}>
              <div className="learning-card-text">
  <TextCard
    title={item?.post_title}
    post_date={item?.post_date}
    post_author={item?.post_author}
  />
</div>
                  </div>
                </a>
              </div>
            ))
          ) : (
            <div className="mt-3">
              <h5>No Posts Available</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LearningComp;